'use strict'
var fuzzysearch = require('fuzzysearch')

module.exports = new FuzzySearchStrategy()

function FuzzySearchStrategy(){
  this.matches = function(string, crit){
    return fuzzysearch(crit, string)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/simple-jekyll-search/src/SearchStrategies/FuzzySearchStrategy.js
// module id = 6
// module chunks = 0